import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING } from '../Utils/Constants';
const sControllerEndpoint = 'RUReservation';


export class UsedRentalsReservationAPI {

  getRULotsForReservation(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '', salesChannelsIds = []) {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (salesChannelsIds)
      params.salesChannelsFilter = salesChannelsIds;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetReservationCarsAvailable', { params });
  }

  getRUEffectiveReservations(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetEffectiveReservationCars', { params });
  }

  getRUAwaitingReservations(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetAwaitingReservationCars', { params });
  }

  getRUHistoricalReservations(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetHistoricalRUReservations', { params });
  }

  getRUHashCodeReservations(featuresHash, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      featuresHash: featuresHash,
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetFeaturesHashReservations', { params });
  }

  getSimilarReservations(ruL4Id, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      ruL4Id: ruL4Id,
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetSimilarReservations', { params });
  }

  createRUReservation(dto) {
    return axios.post(getBackendURL() + sControllerEndpoint + '/CreateRuReservation', dto);
  }

  extendRUReservation(ruReservationId, ruReasonId, numDays) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/ExtendRuReservation?reservationId=' + ruReservationId + '&reasonId=' + ruReasonId + '&numDays=' + numDays);
  }

  cancelRUReservation(ruReservationId, ruReasonId) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/CancelRuReservation?reservationId=' + ruReservationId + '&reasonId=' + ruReasonId);
  }

}

export default UsedRentalsReservationAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsReservationAPI.js